<template>
  <div id="app">
    <myheader></myheader>
    <router-view @loaded="onRouteActivated" />
    <!-- <div v-if="!isRouteLoaded" class="loading">loading...</div> -->
    <myfooter v-if="isRouteLoaded"></myfooter>
  </div>
</template>
<script>
import myfooter from "@/components/footer.vue";
import myheader from "@/components/header.vue";
export default {
  components: {
    myheader,
    myfooter,
  },
  data() {
    return {
      isRouteLoaded: false,
    };
  },
  mounted() {
    $(window).scroll(function() {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > 30) {
        $(".container_box").addClass("active");
      } else {
        $(".container_box").removeClass("active");
      }
    });
  },
  methods: {
    onRouteActivated() {
      this.isRouteLoaded = true;
    },
  },
};
</script>
<style lang="scss">
.loading {
  text-align: center;
  line-height: 60vh;
  font-size: 30px;
}
</style>
